<template>
  <div id="ModalSettings">
    <div class="modal fade" :class="{ 'show': show }">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-normal">Settings</h5>
            <button type="button" class="btn-close text-dark" @click="$emit('close')"></button>
          </div>
          <div class="modal-body">
            <!-- <ul class="nav nav-tabs px-4">
              <li class="nav-item">
                <a class="nav-link text-dark text-sm " :class="{ 'active fw-bold': display_info == 1 }"
                  @click="display_info = 1">English</a>
              </li>
              <li class="nav-item">
                <a class="nav-link text-dark text-sm" :class="{ 'active fw-bold': display_info == 2 }"
                  @click="display_info = 2">Thai</a>
              </li>
            </ul> -->
            <div class="row">
              <div class="col-12">
                <label class="form-check-label">
                    <input class="form-check-input me-1" type="checkbox" v-model="c_all">
                    <small><b class="fw-blod">Show All Content:</b> No restrictions based on age suitability.</small>
                </label>
              </div>
              <div class="col-12">
                <label class="form-check-label">
                    <input class="form-check-input me-1" type="checkbox" v-model="c_13">
                    <small><b class="fw-blod">Suitable for 13 and Under:</b> Only show content classified as suitable for users aged 13 years or younger.</small>
                </label>
              </div>
              <div class="col-12">
                <label class="form-check-label">
                    <input class="form-check-input me-1" type="checkbox" v-model="c_20">
                    <small><b class="fw-blod">Suitable for 20 and Over:</b> Restrict content to that classified as suitable for users aged 20 years or older.</small>
                </label>
              </div>
            </div>
          </div>
          <div class="modal-footer text-center" style="display:block;">
            <button type="button" class="btn btn-sm btn-primary transform-none py-2" @click="$emit('close')">
              Save</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show" v-if="show"></div>
  </div>
</template>

<script>
export default {
  name: 'ModalSettings',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      display_info: 1,
      c_all: true,
      c_13: false,
      c_20: false,
    }
  },
  methods:{
    updateSettings(){
      this.$emit('updateSettings', this.c_all_val, this.c_13_val, this.c_20_val);
    }
  },
  computed:{
    c_all_val(){
      return this.c_all ? 1 : 0
    },
    c_13_val(){
      return this.c_13 ? 1 : 0
    },
    c_20_val(){
      return this.c_20 ? 1 : 0
    },
  },
  watch:{
    show(val){
      console.log(val)
    },
    c_all_val(val){
      if(val){
        this.c_13 = false;
        this.c_20 = false;
      }
    },
    c_13(val){
      if(val) this.c_all = false;
    },
    c_20(val){
      if(val) this.c_all = false;
    }
  }
}
</script>

<style scoped>
.fw-blod{
  font-weight: bold;
}
</style>